import React, { PureComponent } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import Button from '../button/button';
import './wizard.less';

class WizardStep extends PureComponent {
  static propTypes = {
    active: PropTypes.bool,
    className: PropTypes.string,
    beforeNext: PropTypes.func,
    prevText: PropTypes.string,
    nextText: PropTypes.string,
    showPrev: PropTypes.bool,
    showNext: PropTypes.bool
  };

  static defaultProps = {
    beforeNext: () => true,
    prevText: 'Back',
    nextText: 'Continue',
    showPrev: null,
    showNext: null,
    active: null
  };

  onPrev = () => {
    this.props.movePrev();
  };

  onNext = () => {
    Promise.resolve(this.props.beforeNext()).then(
      result => (result !== false ? this.props.moveNext() : null)
    );
  };

  render() {
    return (
      <div
        className={classnames('wizard__step', {
          'wizard__step--active': this.props.active,
          'wizard__step--invisible': this.props.active && this.props.invisible
        })}
      >
        <div className={classnames(this.props.className, 'wizard__content')}>
          {this.props.children}
        </div>
        {this.props.showPrev ? (
          <Button onClick={this.onPrev}>{this.props.prevText}</Button>
        ) : null}
        {this.props.showNext ? (
          <Button onClick={this.onNext}>{this.props.nextText}</Button>
        ) : null}
      </div>
    );
  }
}

class Wizard extends PureComponent {
  numSteps;
  elementRef;

  static Step = WizardStep;

  static propTypes = {
    currentStep: PropTypes.number,
    onChange: PropTypes.func,
    className: PropTypes.string,
    showPrev: PropTypes.bool,
    showNext: PropTypes.bool
  };

  static defaultProps = {
    showNext: true
  };

  constructor(props) {
    super(props);
    this.state = {
      inTransition: false,
      currentStep: 1
    };
  }

  componentWillMount() {
    this.numSteps = this.props.children.length;
  }

  componentWillReceiveProps({ currentStep }) {
    if (currentStep !== this.state.currentStep) {
      this.transitionTo(currentStep);
    }
  }

  transitionTo = step => {
    this.setState(() => {
      setTimeout(() => {
        this.setState(() => {
          setTimeout(() => {
            this.setState(() => {
              return { inTransition: false };
            });
          }, 200);
          return { currentStep: step };
        });
      }, 200);
      return { inTransition: true };
    });
  };

  prevStep = () => {
    if (this.state.currentStep > 1) {
      const currentStep = this.state.currentStep - 1;
      if (this.props.onChange) {
        this.props.onChange(currentStep);
      }
      this.transitionTo(currentStep);
    }
  };

  nextStep = () => {
    if (this.state.currentStep < this.numSteps + 1) {
      const currentStep = this.state.currentStep + 1;
      if (this.props.onChange) {
        this.props.onChange(currentStep);
      }
      this.transitionTo(currentStep);
    }
  };

  storeRef = el => {
    this.elementRef = el;
  };

  render() {
    return (
      <div
        style={{
          width: this.props.width,
          height: this.props.height
        }}
        ref={this.storeRef}
        className={classnames(this.props.className, 'wizard')}
      >
        {React.Children.map(this.props.children, (child, idx) =>
          React.cloneElement(child, {
            movePrev: this.prevStep,
            moveNext: this.nextStep,
            showPrev:
              child.props.showPrev !== false &&
              this.props.showPrev &&
              this.state.currentStep > 1,
            showNext:
              child.props.showNext !== false &&
              this.props.showNext &&
              this.state.currentStep < this.numSteps,
            invisible: this.state.inTransition,
            active: idx === this.state.currentStep - 1
          })
        )}
      </div>
    );
  }
}

export default Wizard;
